import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");

// TEMPORARY FIX: Force client-side rendering instead of hydration
// The prerendered HTML has inline animation styles (opacity, transform) that
// don't match React's initial render state, causing React to render duplicate
// content instead of properly taking over the DOM.
// 
// Solution: Clear the prerendered content and do a fresh client render.
// This sacrifices the SEO benefit of prerendering but fixes the duplicate
// content bug. Prerendered HTML is still there for crawlers (they don't
// execute JS), but real users get a clean React render.

if (rootEl && rootEl.children && rootEl.children.length > 0) {
  // Clear prerendered content safely (avoid XSS vulnerability from innerHTML)
  rootEl.textContent = '';
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
